$(document).ready(function(){
   $(document).on("click", ".new-text-terms label", function(){
     let bnCheck = $(".styled-checkbox")
     console.log(bnCheck[0].checked)
  
     if(bnCheck[0].checked){
       $(".btn-checkout-custom").attr("disabled", true)
     }else{
       $(".btn-checkout-custom").attr("disabled", false)
     }
   })

  /* Masonry Stores */

   var elem = document.querySelector('.octo-page-stores');
      var msnry = new Masonry( elem, {
        // options
        itemSelector: '.octo-masonry',
        columnWidth: 200
      });

      // element argument can be a selector string
      //   for an individual element
      var msnry = new Masonry( '.octo-page-stores', {
        // options
      });
    
    PDFObject.embed("https://cdn.shopify.com/s/files/1/0247/1123/3570/files/thl_web.pdf?v=1690605587", "#wrapper-embed");

    /* PRODUCT INFO INITIAL*/ 
  if ($('body').hasClass('template-product')) {


   let checkButton = $('button[type="submit"] > span.t4s-btn-atc_text').text()
    checkButton = checkButton.trim()
    console.log(checkButton)
      if(checkButton === "Pre-order") {       
        $(".area--views--stock p.current-inventory").remove()        
      }else{
        console.log("NO")
      }
      
    let min = $(".area--views--stock > p.views-product").attr("data-min")
        min = parseInt(min)
    let max = $(".area--views--stock > p.views-product").attr("data-max")
        max = parseInt(max)
    let numberRandom = Math.round(Math.random() * (max - min) + min);
    $(".area--views--stock > p.views-product #mathRound").html(numberRandom)  

    /* PRODUCT INFO CHANGE*/ 
    $(document).on("click", "div[data-swatch-list] > div, div.t4s-swatch__list > div", function(){
      let currSwatch = $(this).attr("data-value")
      let varChanged = $(`.area--views--stock > input[value='${currSwatch}']`).attr("data-qty")
      let min = $(".area--views--stock > p.views-product").attr("data-min")
          min = parseInt(min)
      let max = $(".area--views--stock > p.views-product").attr("data-max")
          max = parseInt(max)
      let numberRandom = Math.round(Math.random() * (max - min) + min);
      
       if(varChanged < 0){
          $(".area--views--stock > p.current-inventory").html(`Only 0 left available`)
       }else{
          $(".area--views--stock > p.current-inventory").html(`Only ${varChanged} left available`)       
       }
      
      $(".area--views--stock > p.views-product #mathRound").html(numberRandom)   
    })

    setInterval(function () {
       let numberRandom = Math.round(Math.random() * (max - min) + min);
       $(".area--views--stock > p.views-product #mathRound").html(numberRandom)
    }, 120000)
  }
   
})/* END ON READY */


